export const getBlogTagFromList = (tagList = [], tagId = '') => {
    let tagItem: any = {};
    for (let i = 0; i < tagList.length; i++) {
        const itemA: any = tagList[i];
        if (itemA.tagUrl === tagId) {
            tagItem = itemA;
            break;
        }
    }
    if (!tagItem.tag && tagList.length) {
        tagItem = tagList[0] || {};
    }
    return tagItem;
};
// 先判断是否自已跳转自己
export const getRedirectUrlHandle = (redirectUrl: string, pathname: string) => {
    if (!redirectUrl) {
        return null;
    }
    try {
        // 如果 redirectUrl 是完整 URL，则只比较路径部分，避免误判
        const urlObj = new URL(redirectUrl);
        const urlPath = urlObj.pathname;
        // 精确比较路径相同的情况，防止自己跳自己
        if (urlPath === pathname && urlObj.origin === 'https://www.ecoflow.com') {
            return null;
        }
    } catch {
        return null;
    }
    return redirectUrl;
};
